import { captureEvent } from '@sentry/react';
import { useEffect, useState } from 'react';
import type { StatusPageSummaryResponse } from 'typings/StatusPageScheduledMaintenance';

export function useIncidentStatus() {
  const [errorStatus, setErrorStatus] = useState<string>();

  useEffect(() => {
    const controller = new AbortController();
    fetch('https://status.apollographql.com/api/v1/summary', {
      signal: controller.signal,
    })
      .then(async (result) => {
        const resultJson = JSON.parse(
          await result.text(),
        ) as unknown as StatusPageSummaryResponse;
        const [ongoingIncident] = resultJson.ongoing_incidents ?? [];
        if (ongoingIncident) {
          setErrorStatus(ongoingIncident.name);
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) {
          captureEvent(new Error('Failed to fetch incident status'));
        }
      });
    return () => controller.abort();
  }, []);

  return errorStatus;
}
